import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpParams } from '@angular/common/http';
import { ConfigServerService, CustomHttp } from '../../../core';
import { RegiaoLocalizacoesFilter, RegiaoLocalizacoesResponse } from '../adapters';
import { REGIOES_LOCALIZACOES_API_RESOURCE } from '../consts';

@Injectable({
    providedIn: 'root'
})
export class RegioesLocalizacoesHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${REGIOES_LOCALIZACOES_API_RESOURCE}`;
    }

    /** Obtem as localizações através das regiões */
    getLocalizacoes(filter: RegiaoLocalizacoesFilter): Observable<RegiaoLocalizacoesResponse> {
        // Params
        let params = new HttpParams();
        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<RegiaoLocalizacoesResponse>(this.pathApi, {params})
                    .pipe(
                        map(response => RegiaoLocalizacoesResponse.fromJSON(JSON.stringify(response)))
                    );
    }
}
